import ActionTypeFact from "../ActionTypeFact";

export default class CargaDeAsociadosBuscados extends ActionTypeFact {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = false;
        nuevoEstado.data = this.payload;
        return nuevoEstado;
    }
}
